import { Get } from "./ApiBase";

export async function GetToken() {
  return await Get("/api/me");
}

export async function RefreshToken() {
  return await Get("/api/refresh");
}